var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemplateVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "#2E3A59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4618_59573)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1842 11.1934C27.1841 11.1934 27.1842 11.1933 27.1842 11.1934L21.6665 13.9516V18.0487L27.1842 20.807C27.235 20.8323 27.2914 20.8443 27.3482 20.8418C27.4049 20.8392 27.4601 20.8222 27.5084 20.7924C27.5567 20.7625 27.5966 20.7208 27.6243 20.6712C27.6518 20.6218 27.6664 20.5661 27.6665 20.5095V11.4914C27.6664 11.4347 27.6518 11.3786 27.6243 11.3291C27.5966 11.2795 27.5567 11.2378 27.5084 11.208C27.4601 11.1781 27.4049 11.1611 27.3482 11.1585C27.2915 11.156 27.2349 11.168 27.1842 11.1934ZM26.2902 9.40429C26.6458 9.22657 27.041 9.14268 27.4382 9.16057C27.8353 9.17846 28.2214 9.29753 28.5596 9.5065C28.8978 9.71547 29.177 10.0074 29.3708 10.3546C29.5645 10.7018 29.6663 11.0927 29.6665 11.4903V20.5095C29.6663 20.9071 29.5645 21.2985 29.3708 21.6457C29.177 21.9929 28.8978 22.2848 28.5596 22.4938C28.2213 22.7028 27.8353 22.8219 27.4382 22.8397C27.041 22.8576 26.6458 22.7737 26.2902 22.596L20.2194 19.5613C19.8805 19.3919 19.6665 19.0456 19.6665 18.6668V13.3335C19.6665 12.9547 19.8805 12.6084 20.2194 12.439L26.2902 9.40429Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33317 9C6.4127 9 5.6665 9.74619 5.6665 10.6667V21.3333C5.6665 22.2538 6.4127 23 7.33317 23H17.9998C18.9203 23 19.6665 22.2538 19.6665 21.3333V10.6667C19.6665 9.74619 18.9203 9 17.9998 9H7.33317ZM3.6665 10.6667C3.6665 8.64162 5.30813 7 7.33317 7H17.9998C20.0249 7 21.6665 8.64162 21.6665 10.6667V21.3333C21.6665 23.3584 20.0249 25 17.9998 25H7.33317C5.30813 25 3.6665 23.3584 3.6665 21.3333V10.6667Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4618_59573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "transparent",
    transform: "translate(0.666504)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateVideo);
export default __webpack_public_path__ + "static/media/template-video.70b39b3c.svg";
export { ForwardRef as ReactComponent };